import {Grid as MUIGrid, GridProps as MUIGridProps} from '@mui/material';

const Grid = (props: MUIGridProps) => {
  return <MUIGrid {...props}>{props.children}</MUIGrid>;
};

export default Grid;
